import { render, staticRenderFns } from "./RecipientMails.vue?vue&type=template&id=710d6892&scoped=true&"
import script from "./RecipientMails.vue?vue&type=script&lang=js&"
export * from "./RecipientMails.vue?vue&type=script&lang=js&"
import style0 from "./RecipientMails.vue?vue&type=style&index=0&id=710d6892&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710d6892",
  null
  
)

export default component.exports